import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OptionsModalEnum } from 'src/app/common/options-modal';

@Component({
  selector: 'app-modal-question',
  templateUrl: './modal-question.component.html',
  styleUrls: ['./modal-question.component.scss']
})
export class ModalQuestionComponent implements OnInit {
  @Input() title: string = '';
  @Input() question: string = '';
  optionsEnum = OptionsModalEnum;
  @Input() options = [this.optionsEnum.ACCEPT, this.optionsEnum.CANCEL];
  @Output() close = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {

  }
}
